<template>
    <div class="form-component">
        <v-form ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="goTo('/PaymentSupplementslist')">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                {{ title }} Complemento de Pago
            </h3>
            
            <v-container fluid class="pa-0">
                <h4>Encabezado</h4>
                <v-layout row wrap>
                    <!-- ROW ONE -->
                    <v-flex xs12 sm3>
                        <v-select class="lance"
                            :items="suppliers"
                            item-text="businessName"
                            item-value="code"
                            v-model="form.supplierCode"
                            label="Proveedor"
                            :rules="[v => (!!v || view) || 'Campo requerido']"
                            v-on:change="onChangeSupplier"
                            :disabled="view">
                            <v-list-tile v-if="form.supplierCode" slot="prepend-item" @click="form.supplierCode = null; form.supplierRFC = null;">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="form.supplierCode" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="O.C."
                            v-model="form.purchaseOrder"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Total de Impuestos"
                            @input="form.totalTaxes = $event.target.value"
                            :value="formatCurrency(form.totalTaxes)"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="No. Factura"
                            v-model="form.invoiceNum"
                            :disabled="view"
                            :rules="[v => !!v || 'Campo requerido']">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW TWO -->
                    <v-flex xs12 sm3>
                        <v-menu
                            ref="date"
                            :close-on-content-click="false"
                            v-model="date"
                            :nudge-right="40"
                            :return-value.sync="form.date"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance no-right-padding"
                                slot="activator"
                                :value="formatDate(form.date)"
                                label="Fecha de Registro"
                                append-icon="event"
                                :disabled="view"
                                :rules="[v => !!v || 'Campo requerido']"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="form.date" no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="form.date=null; $refs.date.save(form.date);">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.date.save(form.date);">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Total Factura"
                            :value="formatCurrency(form.invoiceTotal)"
                            @input="form.invoiceTotal = $event.target.value"
                            :disabled="view"
                            :rules="[v => !!v || 'Campo requerido']">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="RFC Cliente"
                            v-model="form.clientRFC"
                            :disabled="view"
                            :rules="[v => !!v || 'Campo requerido']">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="RFC Proveedor"
                            v-model="form.supplierRFC"
                            :disabled="view"
                            :rules="[v => !!v || 'Campo requerido']"
                            v-on:change="onChangeRFC">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW THREE -->
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Moneda"
                            v-model="form.currency"
                            :disabled="view"
                            :rules="[v => !!v || 'Campo requerido']">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-select class="lance"
                            :items="status"
                            item-text="internalText"
                            item-value="id"
                            v-model="form.status"
                            label="Estatus"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                            <v-list-tile v-if="form.status" slot="prepend-item" @click="form.status = null;">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="form.status" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Nom. Comercial Whirlpool"
                            v-model="form.clientName"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW FOUR -->
                     <v-flex xs12 sm9>
                         <v-text-field class="lance"
                            label="Comentarios"
                            v-model="form.commentManual"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>

                    <!-- ROW FIVE -->
                     <v-flex xs12 sm9>
                         <v-text-field class="lance"
                            label="UUID de Complemento de Pago"
                            v-model="form.paymentSupplementUUID"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid || sending">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<style scoped>
    h4 {
        font-size: 20px;
        margin-bottom: 18px;
    }
</style>


<script>
    import { events } from '../main';
    import { _ } from 'underscore';
    import moment from 'moment-timezone';
    import XLSX from 'xlsx';
    import ImageSelect from "./ImageSelect";
    import WorkbookGrid from "./WorkbookGrid";

    export default {
        components: {
            ImageSelect,
            WorkbookGrid,
        },
        data() {
            return {
                suppliers: [],
                status: [],
                loading: true,
                valid: true,
                sending: false,
                view: false,
                date: false,
                id: '',
                title: '',
                form: {
                },
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                this.$router.push(url);
            },
            goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            },
            formatCalendarHeader(val) {
                return moment(val).locale("es").format("MMMM YYYY");
            },
            formatDate(date) {
                if(date) {
                    var ndate = moment(date).locale("es").format("DD/MMM/YYYY");
                    var mes = ndate.split("/")[1];
                    var nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
                    return ndate.replace(mes, nmes);
                }
                return '';
            },
            formatTime(date) {
                return date ? moment(date).locale("es").format("HH:mm:ss a") : '';
            },
            formatCurrency(num) {
                return "$ " + Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            },
            getStatuses: function() {
                this.$http.get('Status/invoiceStatuses')
                    .then(response => {
                        var list = response.body;
                        this.status = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de estatus');
                        console.error(error);
                    })
            },
            getSuppliers: function() {
                this.$http.get('PaymentSupplements/Suppliers')
                    .then(response => {
                        var list = response.body;
                        this.suppliers = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de proveedores');
                        console.error(error);
                    })
            },
            dataInit() {
                var self = this;
                this.getSuppliers();
                this.getStatuses();
                this.getRegistry(this.id);
            },
            getRegistry(id) {
                var self = this;
                this.$http.get('PaymentSupplements/form/' + this.id)
                .then(response => {
                    self.form = response.body.Documents;
                    
                    if (this.form.supplierRFC != this.form.supplier.rfc) {
                        this.form.supplierCode = null;
                    }
                    
                    this.form.paymentSupplementUUID = this.form.documentPaymentInvoice ? this.form.documentPaymentInvoice.documentPayment.document.invoiceUUID : null;
                    this.loading = false;
                }, error => {
                    self.snackbar('Error al obtener registro');
                    this.goBack();
                });
            },
            onChangeSupplier(sender) {
                let supplier = this.suppliers.find(x => x.code == sender);
                if (supplier) {
                    this.form.supplierRFC = supplier.rfc;
                } else {
                    this.form.supplierRFC = null;
                }
            },
            onChangeRFC(sender) {
                let supplier = this.suppliers.find(x => x.rfc == sender);
                if (supplier) {
                    this.form.supplierCode = supplier.code;
                } else {
                    this.form.supplierCode = null;
                }
            },
            save() {
                self = this;

                if (this.$refs.form.validate()) {
                    this.sending = true;
                    this.$http.put('PaymentSupplements/' + self.id, self.form)
                        .then(response => {
                            self.snackbar('Registro actualizado con éxito');
                            this.goBack();                               
                        }, error => {
                            self.sending = false;                                
                            var message = error.body && error.body.message ? error.body.message : 'Error al actualizar registro';
                            self.snackbar(message);
                            console.error(error);
                    });
                }
            },
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.$route.name.includes('detail') ) {
                this.view = true;
                this.title = "Detalle";
            } else if (this.$route.name.includes('edit')) {
                this.view = false;
                this.title = "Editar";
            }
            this.dataInit();
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
        computed: {
        }
    }
</script>